'use client'

/**
 * Initializes the PostHog analytics SDK for the admin dashboard.
 * Rendered once in apps/web/src/app/layout.tsx alongside the logger.
 *
 * Required env vars (set in Vercel dashboard):
 *   NEXT_PUBLIC_POSTHOG_KEY   — PostHog project API key
 *   NEXT_PUBLIC_POSTHOG_HOST  — PostHog ingestion host (e.g. "https://us.i.posthog.com")
 */

import { useEffect } from 'react'
import posthog from 'posthog-js'
import { markPostHogInitialized } from '@auctogon/admin-isomorphic/isomorphic/posthog-state'

const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY || ''
const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com'

let initialized = false

export default function PostHogInit() {
  useEffect(() => {
    if (!POSTHOG_KEY) return
    // Guard only the init call against React 19 strict-mode double-mount.
    // markPostHogInitialized() is intentionally outside the guard so it always
    // runs when the effect fires — ensuring the ready-callbacks are flushed on
    // both the first and (simulated) second mount without calling posthog.init twice.
    if (!initialized) {
      initialized = true
      posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        // Disable auto-pageview since we fire $pageview manually on route changes
        capture_pageview: false,
        capture_pageleave: true,
        // Mask all input values by default to avoid capturing PII
        autocapture: false,
        // Session recording is independent of autocapture — it captures video-like
        // replays and must be masked separately. maskAllInputs prevents financial
        // data (invoice amounts, bid values) from appearing in session replays.
        session_recording: { maskAllInputs: true },
      })
    }
    markPostHogInitialized()
  }, [])

  return null
}
